import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faBars } from "@fortawesome/free-solid-svg-icons";
import wlogo from "../../assets/Images/White_TCL_logo.png";
import wlogo1 from "../../assets/Images/TCL_logo (1).png";
import wha from "../../assets/Images/wha.jpg";
import "./Navv.css";

const Nav = () => {
  const navigate = useNavigate();
  const [isToggled, setIsToggled] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  const handleToggle = () => setIsToggled(!isToggled);
  const closeNavbar = () => setIsToggled(false);

  const handleLogOut = () => {
    alert("You are Logging out...");
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("token");
    setIsLoggedIn(false);
    setIsToggled(false);
    setTimeout(() => navigate("/"), 1500);
  };

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    const handleResize = () => setIsDesktop(window.innerWidth >= 992);

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Determine which logo to show
  const logoSrc = isScrolled || (isHovered && isDesktop) ? wlogo1 : wlogo;

  return (
    <nav
      className={`navbar navbar-expand-lg p-0 ${isScrolled ? "scrolled" : ""} ${
        isHovered && isDesktop ? "hovered" : ""
      }`}
      onMouseEnter={() => isDesktop && setIsHovered(true)}
      onMouseLeave={() => isDesktop && setIsHovered(false)}
    >
      <div className="container px-4 d-flex">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <NavLink to="/" className="navbar-brand fw-bold" onClick={closeNavbar}>
            {/* Desktop Logo */}
            <img
              src={logoSrc}
              className="d-none d-md-block"
              width="150"
              alt="Logo"
            />
            {/* Mobile Logo */}
            <img
              src={logoSrc}
              className="d-block d-md-none"
              width="120"
              alt="Logo"
            />
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            onClick={handleToggle}
            tabIndex="-1"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>

        <div className={`collapse navbar-collapse ${isToggled ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto d-flex align-items-start">
            <li className="nav-item me-3 text-nowrap">
              <NavLink to="/" className="nav-link" onClick={closeNavbar}>
                Home
              </NavLink>
            </li>
            <li className="nav-item me-3 text-nowrap">
              <NavLink to="/bikepackage" className="nav-link" onClick={closeNavbar}>
                Bike Package
              </NavLink>
            </li>
            <li className="nav-item me-3 text-nowrap">
              <NavLink to="/carpackage" className="nav-link" onClick={closeNavbar}>
                Car Package
              </NavLink>
            </li>
            <li className="nav-item me-3 text-nowrap">
              <a
                href="https://travellerchoiceladakh.com/blog/"
                className="nav-link"
                onClick={closeNavbar}
                target="_blank"
              >
                Blog
              </a>
            </li>
            <li className="nav-item me-3 text-nowrap">
              <NavLink to="/contact-us" className="nav-link" onClick={closeNavbar}>
                Contact Us
              </NavLink>
            </li>

            {!isLoggedIn ? (
              <li className="nav-item me-3 text-nowrap">
                <NavLink to="/login" className="nav-link" onClick={closeNavbar}>
                  Log In
                </NavLink>
              </li>
            ) : (
              <li className="nav-item dropdown me-3 text-nowrap">
                <button
                  className="nav-link dropdown-toggle"
                  id="userDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={handleToggle}
                >
                  <FontAwesomeIcon icon={faUser} />
                </button>

                <div
                  className={`dropdown-menu ${isToggled ? "show" : ""}`}
                  aria-labelledby="userDropdown"
                >
                  <NavLink to="/Myprofile" className="dropdown-item" onClick={closeNavbar}>
                    Profile
                  </NavLink>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      handleLogOut();
                      closeNavbar();
                    }}
                  >
                    Log Out
                  </button>
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://api.whatsapp.com/send?phone=+919149516495&text=Hi there! 👋 How can we assist you today?"
        className="whatsapp_btn"
      >
        <img src={wha} alt="whatsapp" className="w-100" />
      </a>
    </nav>
  );
};

export default Nav;
